import { useEffect, RefObject } from 'react';

export const useFocusTrap = (
  isActive: boolean,
  containerRef: RefObject<HTMLElement>,
  disabled: boolean = false
) => {
  useEffect(() => {
    if (!isActive || disabled || !containerRef.current) return;

    const focusableSelectors = [
      'button',
      'a[href]',
      'input',
      'select',
      'textarea',
      "[tabindex]:not([tabindex='-1'])",
    ];

    const containerEl = containerRef.current;
    const focusableElements = containerEl.querySelectorAll<HTMLElement>(
      focusableSelectors.join(',')
    );
    const firstEl = focusableElements[0];
    const lastEl = focusableElements[focusableElements.length - 1];

    const trap = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            lastEl?.focus();
          }
        } else {
          if (document.activeElement === lastEl) {
            e.preventDefault();
            firstEl?.focus();
          }
        }
      }
    };

    window.addEventListener('keydown', trap);
    return () => window.removeEventListener('keydown', trap);
  }, [isActive, disabled, containerRef]);
};
